module.exports = __webpack_public_path__ + "img/LU_tia高機能美容精華液.383032a9.png";